<template>
  <div class="nav-providers">
    <div class="nav-providers__wrapper">
      <div class="nav-providers__list">
        <div
          v-for="(item) in viewModeList"
          :key="item.icon"
          class="nav-providers__item"
        >
          <UiBtn
            class="nav-providers__btn"
            color="gray"
            :text="item.name"
            :icon="item.icon"
            :icon-src="item.iconSrc"
            :size="{
              default: 's',
              tablet: 'm',
            }"
            :to="item.url"
            :active="item.active"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DISPLAY_MODE, QUERY } from '@/components/Lobby/enum.js'

export default {
  name: 'NavProviders',
  computed: {
    ...mapGetters('lobby', ['get_sectionList', 'get_currentSection']),
    currentSection() {
      return this.get_currentSection(this.$route)
    },
    viewModeList() {
      return [
        {
          name: this.$tc('lobby.navs.allGames'),
          icon: 'lobby/grids-cube',
          url: { query: { [QUERY.DISPLAY_MODE]: DISPLAY_MODE.LIST } },
          active: this.$route.query[QUERY.DISPLAY_MODE] === DISPLAY_MODE.LIST,
        },
        {
          name: this.$tc('lobby.navs.filterCat'),
          icon: 'lobby/grids-flat',
          url: { query: {} },
          active: !this.$route.query[QUERY.DISPLAY_MODE],
        },
        {
          name: this.$tc('lobby.navs.allProviders'),
          icon: 'lobby/audio-games',
          url: this.localePath(`/${this.currentSection?.term}`),
        },
      ]
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
